
import React, { useEffect, useState } from 'react';
import ReactFlow, {
  Controls,
  Background,
  NodeProps,
  Handle,
  Position,
  NodeTypes,
  getBezierPath,
  EdgeProps,
  EdgeTypes,
} from 'reactflow';
import 'reactflow/dist/style.css';
import { Nav, OverlayTrigger } from 'react-bootstrap';
import "./Index.scss"
import { Link} from 'react-router-dom';
import { useContent } from './newHomeHook';
import { useMaster } from '../../Contexts/MasterContext';
import { getScopeEnvList } from '../../services/activeScope';

const SideMessage: React.FC = () => {
  return (
    <div style={{ 
      position: 'absolute',
      top: '10%',
      left: '2%', 
      maxWidth: '300px',
      color: '#1E2134',
      fontSize: '2rem',
      fontWeight: 'bold',
      lineHeight: '1.5',
      zIndex: 10,
      marginLeft:"300px"
    }}>
      <div>Five Steps</div>
      <div style={{width:"400px"}}>to Manage and Govern</div>
      <div>Your Data Platform</div>
    </div>
  );
};

const CustomNode = ({ data }: NodeProps) => {
  const useWaitForEnvList = (onFound: (value: any) => void) => {
    useEffect(() => {
      let attempts = 0;
      const maxAttempts = 4;
  
      const interval = setInterval(() => {
        const rawValue = getScopeEnvList();
  
        // Check if value exists and is not the string "null"
        if (rawValue && rawValue !== "null") {
          try {
            const parsed = JSON.parse(rawValue);
  
            if (parsed) {
              onFound(parsed);           // ✅ callback
              clearInterval(interval);   // ✅ stop interval
            }
          } catch (err) {
            console.error("Invalid JSON in envList:", err);
            // still stop if value is malformed
            clearInterval(interval);
          }
  
          return; // ensure we don’t proceed further on this tick
        }
  
        attempts += 1;
        if (attempts >= maxAttempts) {
          clearInterval(interval); // 🔁 stop after 4 attempts
        }
      }, 1000);
  
      return () => clearInterval(interval); // 🧼 clean on unmount
    }, [onFound]);
  };
  const {refreshEnvStatus} = useMaster();
  const [updateState, setUpdateState] = useState(false)

  useEffect(()=>{
    if(updateState){
      refreshEnvStatus(); 
    }
  },[updateState])
  
  
  useWaitForEnvList((envList) => {
    console.log("envList found:", envList);
    setUpdateState(true)
  });
  const { getContentByHeading, determineRouteAndActive } = useContent();

  const { to, active } = determineRouteAndActive(data.label);

  return (
    <>
    <Nav.Link as={Link} to={to} active={active}>
    <div style={{ 
      padding: 10, 
      border: '1px solid #ddd', 
      borderRadius: 5, 
      backgroundColor: '#fff', 
      width: '140px',  
      textAlign: 'center',
      display:"flex",
      flexDirection:"column",
      justifyContent:"center",
      alignItems:"center",
    }}>
      <div style={{width:"100%", display:"flex", flexDirection:"row"}}>
        <div style={{width:"20%", borderRadius:"60%", border:"1px solid black", height:"10%", display:"flex", justifyContent:"center", alignItems:"center", fontSize:"12px"}}>{data.step}</div>
        <div style={{width:"80%", marginRight:20, display:"flex", justifyContent:"center", alignItems:"center"}}>
        <OverlayTrigger
          key="top"
          placement={data.label === "Monitor & Govern Your Data" ? "top" : data.label === "Orchestration Modeling" ? "left" : "right"}
          overlay={
              <div className="custom-tooltip">
                {/* {getContentByHeading(data.label)} */}
                {getContentByHeading(data.label).split('\n').map((line, index) => (
                  <React.Fragment key={index}>
                    {line}
                    <br />
                  </React.Fragment>
                ))}
              </div>
          }
        >
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width:"50px", }}>
          {data.image}
        </div>
      </OverlayTrigger>

      {data.label !== "Select Data Source" && (
        <Handle type="target" position={Position.Left} style={{ background: '#555' }} isConnectable={false}/>
      )}
      {data.label === "Select Data Source" && (
      <Handle type="target" position={Position.Bottom} style={{ background: '#555' }} isConnectable={false}/>
      )}
      {data.label === "Data Modeling" && (
      <Handle type="source" position={Position.Right} style={{ background: '#555' }} isConnectable={false}/>
      )}
      {data.label === "Run Automation" && (
      <Handle type="source" position={Position.Right} style={{ background: '#555' }} isConnectable={false}/>
      )}
      {data.label === "Orchestration Modeling" && (
      <Handle type="source" position={Position.Right} style={{ background: '#555' }} isConnectable={false}/>
      )}
      {(  data.label === "Monitor & Govern Your Data") && (
      <Handle type="source" position={Position.Bottom} style={{ background: '#555' }} isConnectable={false}/>
      )} 
      {(data.label === "Select Data Source" &&
      <Handle type="source" position={Position.Right} style={{ background: '#555' }} isConnectable={false}/>
      )} 
        </div>
      </div>
      <div style={{ width:"100%"}}>
        <div style={{ fontWeight: 'bold', marginBottom: 5 , fontSize:"10px"}}>{data.label}</div>
      </div>
    </div>
    </Nav.Link>
    </>
  );
};

const CustomEdge = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style = {},
  markerEnd,
}: EdgeProps) => {
  const [edgePath] = getBezierPath({
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
  });

  return (
    <>
      <defs>
        <marker
          id="arrowhead"
          viewBox="0 0 10 10"
          refX="8"
          refY="5"
          markerWidth="6"
          markerHeight="6"
          orient="auto"
        >
          <path d="M 0 0 L 10 5 L 0 10 z" fill="#555" />
        </marker>
      </defs>
      <path
        id={id}
        style={{ ...style, strokeDasharray: '12,5' }}
        className="react-flow__edge-path"
        d={edgePath}
        markerEnd="url(#arrowhead)"
      />
    </>
  );
};

const CustomEdgeToBottom = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style = {},
  markerEnd,
}: EdgeProps) => {
  // Calculate a path that moves down to the bottom of the screen and then horizontally to the target
  const midY = Math.max(sourceY, targetY) + 80; // Adjust this value to control how far down the edge travels

  const edgePath = `
    M ${sourceX},${sourceY}
    L ${sourceX},${midY}
    L ${targetX},${midY}
    L ${targetX},${targetY}
  `;

  return (
    <>
      <defs>
        <marker
          id="arrowhead"
          viewBox="0 0 10 10"
          refX="8"
          refY="5"
          markerWidth="6"
          markerHeight="6"
          orient="auto"
        >
          <path d="M 0 0 L 10 5 L 0 10 z" fill="#555" />
        </marker>
      </defs>
      <path
        id={id}
        style={{ ...style, strokeDasharray: '12,5' }}
        className="react-flow__edge-path"
        d={edgePath}
        markerEnd="url(#arrowhead)"
      />
    </>
  );
};

const nodeTypes: NodeTypes = {
  custom: CustomNode,
};

const edgeTypes: EdgeTypes = {
  custom: CustomEdge,
  customBottom: CustomEdgeToBottom,
};


const NewHome: React.FC = () => {
  const { nodes,edges,onConnect} = useContent();
  
  return (
    <div style={{ height: '90vh', width: '90vw' }}>
      <SideMessage />
      <ReactFlow
        nodes={nodes}
        edges={edges}
        panOnDrag={false}
        panOnScroll={false}
        zoomOnScroll={false}
        zoomOnDoubleClick={false}
        onConnect={onConnect}
        fitView
        fitViewOptions={{ padding: 0.2 }}
        nodeTypes={nodeTypes}
        edgeTypes={edgeTypes}
        nodesConnectable={false} // Disable node connection
        nodesDraggable={false} // Disable node dragging
      >
        {/* <MiniMap /> */}
        <Controls />
        <Background color="#aaa" gap={16} />
      </ReactFlow>
    </div>
  );
};

export default NewHome;